





















































































import { Component, Vue } from 'vue-property-decorator';
import { Bundle } from '@/connectors/bundles/bundle.model';
import { BundlesConnector } from '@/connectors/bundles/bundles.connector';
import { TaskHelper } from '@/utils/task.helper';

@Component
export default class BundleOverviewIndex extends Vue {
  bundlesConnector: BundlesConnector = new BundlesConnector();

  loading: boolean = true;
  bundles: Bundle[] = [];

  headers: any[] = [
    {
      text: 'Beitrag',
      value: 'thumbnailUrl',
      width: '120px'
    },
    {
      text: 'Name',
      value: 'name'
    },
    {
      text: 'Startdatum',
      value: 'startDate',
      width: '135px'
    },
    {
      text: 'Enddatum',
      value: 'endDate',
      width: '135px'
    },
    {
      text: 'Views',
      value: 'completedByCount',
      width: '90px'
    },
    {
      text: 'Rating',
      value: 'rating',
      width: '120px'
    }
  ];

  async mounted() {
    try {
      this.bundles = await this.bundlesConnector.getAll();
    } finally {
      this.loading = false;
    }
  }
}
